import script from "./registerSjPassList.vue?vue&type=script&setup=true&lang=js"
export * from "./registerSjPassList.vue?vue&type=script&setup=true&lang=js"

import "./registerSjPassList.vue?vue&type=style&index=0&id=0c9e3cff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9e3cff"]])

export default __exports__